<template>
  <div>
      <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'g-tabs',
    props: {
        selected: {
            type: String,
            required: true
        }
    },
    mounted() {
        if(this.$children.length === 0) {
            console && console.warn && console.warn('tabs的子组件应该是tabs-head和tabs-nav,但你没有写子组件')
        }
        this.$children.forEach(item =>{
            if(item.$options.name === 'g-tabs-head') {
                item.$children.forEach(vm => {
                    if('g-tabs-head-item' === vm.$options.name && vm.name === this.selected){
                        this.eventBus.$emit('update:selected',this.selected,vm)
                    }
                })
            }
        })
        this.eventBus && this.eventBus.$on('update:selected', (name) => {
            this.$emit('update:selected',name)
        })
    },
    data() {
        return {
            eventBus: new Vue()
        }
    },
    provide() {
       return {
            eventBus: this.eventBus
       }
    },
    destroyed() {
        document.getElementById("g-line").remove()
    }
}
</script>

<style lang="scss" scoped>

</style>